import React from 'react';
import BaseSimpleItemBrowserHeader from "../BaseSimplePage/BaseSimpleItemBrowserHeader";
import ItemBrowserHeaderSelect from "../../components/ItemBrowserHeaderSelect";
import ItemBrowserHeaderSimpleSelect from "../../components/ItemBrowserHeaderSimpleSelect";

const EventsMuseumItemBrowserHeader = ({
                                             cityId,
                                             setCityId,
                                             locationId,
                                             setLocationId,
                                             tagId,
                                             setTagId,
                                             sphereId,
                                             setSphereId,
                                             cardType,
                                             setCardType,
                                             ...restProps
                                         }) => {


    function renderExtraContent() {
        return (
            <div style={{marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <ItemBrowserHeaderSelect
                    label="Город"
                    selectedId={cityId}
                    setSelectedId={setCityId}
                    apiName2="cities"
                    specialOptions={[{id: 0, name: "(все)"}]}
                    showIds={true}
                />
                <ItemBrowserHeaderSelect
                    label="Локация"
                    selectedId={locationId}
                    setSelectedId={setLocationId}
                    apiName2="locations"
                    specialOptions={[{id: 0, name: "(все)"}]}
                    showIds={true}
                />
                <ItemBrowserHeaderSelect
                    label="Наличие сферы"
                    selectedId={sphereId}
                    setSelectedId={setSphereId}
                    apiName2="spheres"
                    specialOptions={[{id: 0, name: "(не важно)"}]}
                    showIds={true}
                />
                <ItemBrowserHeaderSelect
                    label="Наличие тега"
                    selectedId={tagId}
                    setSelectedId={setTagId}
                    apiName2="tags"
                    specialOptions={[{id: 0, name: "(не важно)"}]}
                    showIds={true}
                />
                <ItemBrowserHeaderSimpleSelect
                    label="Тип карточек"
                    options={cardTypeOptions}
                    value={cardType}
                    setValue={setCardType}
                />
            </div>
        );
    }

    return (
        <BaseSimpleItemBrowserHeader
            {...restProps}
            renderExtraContent={renderExtraContent}
        />
    );
};

const cardTypeOptions = [
    {id: "all", name: "(все)"},
    {id: "active", name: "Только активные"},
    {id: "deleted", name: "Только архивные"},
];

export default EventsMuseumItemBrowserHeader;